module.exports = __webpack_public_path__ + "img/cst_website_active.c17a36e1.svg";